import { Link,useNavigate } from "react-router-dom";

const ExpertiesCard = (props) => {
    const navigate = useNavigate();
  const handleImageClick = () => {
    navigate(props.link);
  };
  return (
    <div className="col s12 l3 card offset-l1">
      <div className="card-image waves-effect waves-block waves-light center">
        <img onClick={handleImageClick} style={props.title === "Robotic surgery" ? { padding: 0 } : {}} className="activator" src={props.image} />
      </div>
      <div className="card-content">
        <span className="card-title activator grey-text text-darken-4">
          {props.title}
          <i className="material-icons right">more_vert</i>
        </span>
        <p>
          <Link to={props.link}><b>Read More...</b></Link>
        </p>
      </div>
      <div className="card-reveal">
        <span className="card-title grey-text text-darken-4">
          {props.title}
          <i className="material-icons right">close</i>
        </span>
        <p>{props.description}</p>
      </div>
    </div>
  );
};
export default ExpertiesCard;
